module.exports = __webpack_public_path__ + "static/media/Attach.b2815a1d.svg";